import { useMutation } from "@tanstack/react-query";
import { putChatChannelChannelIdName } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type MutationParams = {
  channelId: string;
  name: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useRenameChatChannelMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ channelId, name }: MutationParams) =>
        putChatChannelChannelIdName({ name }, channelId),
    ),
    onSuccess,
    onError,
  });
